import styled from 'styled-components';

export const CellWrap = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  min-width: 0;
`;

// Lives inside a table cell, so it carries no border or fixed footprint.
export const CellCopyButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  padding: 0.2rem;
  border: none;
  border-radius: 0.25rem;
  background: none;
  color: ${({ theme }) => theme.midGrey};
  cursor: pointer;
  transition:
    color 0.15s ease,
    background 0.15s ease;

  &:hover:not(:disabled) {
    color: ${({ theme }) => theme.dark};
    background: ${({ theme }) => theme.lightGrey};
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;
